import request from '@/utils/request';

/**
 * C 端 Catalog（DS-FE-JACKPOT-20260911 v1.4）
 * Base: /liyuan-trade/jackpot
 * 勿对接未上线的 POST /sync/prepare。
 */

/** 功能开关：{ enabled, publicRoundV2 }；关闸也可调 */
export function getJackpotFeature() {
  return request.get('/liyuan-trade/jackpot/feature');
}

/** 夺宝场次列表：{ list, total }；形状随 publicRoundV2 */
export function listJackpotRounds(params = {}) {
  return request.get('/liyuan-trade/jackpot/rounds', params);
}

/**
 * 我的参与记录（大厅「我的预测」）：{ list, total }；须登录。
 * Catalog OpID: jackpotMyParticipationsUsingGET
 * 勿用 GET /rounds 再本地筛 joined（列表无个人字段会空）。
 * 可选 userId 须与当前登录 uid 一致；limit 默认 20、上限 50。
 * list 项含场次展示字段 + myShares / mySpent / joined / isWinner。
 * 勿传他人 userId；往期开奖走 GET /history。
 */
export function listJackpotMyParticipations(params = {}) {
  return request.get('/liyuan-trade/jackpot/myParticipations', params);
}

/** 场次详情：{ round, myPurchases? }；登录时带购票区间与 tickets[] */
export function getJackpotRound(id) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}`);
}

/** 参与者列表（脱敏）：{ list, total }；limit 上限 50 */
export function listJackpotParticipants(id, params = {}) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}/participants`, params);
}

/** 号码盘占用：TicketAxisVO { totalShares, soldShares, remainShares, soldRanges, mine? } */
export function getJackpotTickets(id) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}/tickets`);
}

/** 往期 SETTLED：{ list, total }；limit 上限 50；勿用 rounds?status=SETTLED */
export function listJackpotHistory(params = {}) {
  return request.get('/liyuan-trade/jackpot/history', params);
}

/** 中心化买入：body { shares?, tickets?, clientRequestId } → BuyResult */
export function buyJackpotShares(id, { shares, tickets, clientRequestId, allowActivity = true }) {
  const body = {
    clientRequestId,
    allowActivity,
  };
  if (Array.isArray(tickets) && tickets.length > 0) {
    body.tickets = tickets;
    body.shares = Number.isFinite(shares) ? shares : tickets.length;
  } else if (Number.isFinite(shares)) {
    body.shares = shares;
  }
  return request.post(`/liyuan-trade/jackpot/rounds/${id}/buy`, body);
}

/** 开奖结果 / 流局验算（无 coverUrl；winner* 仅验算） */
export function getJackpotResult(id) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}/result`);
}

/** 链上对齐状态 */
export function getJackpotSyncStatus() {
  return request.get('/liyuan-trade/jackpot/sync/status');
}

/** EOA 上报对齐 tx → { ok: true } */
export function confirmJackpotSync({ debtIds, txHash }) {
  return request.post('/liyuan-trade/jackpot/sync/confirm', { debtIds, txHash });
}
